var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSobre(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 13C25 19.9035 19.4035 25.5 12.5 25.5C5.59644 25.5 0 19.9035 0 13C0 6.09644 5.59644 0.5 12.5 0.5C19.4035 0.5 25 6.09644 25 13ZM12.5 20.1875C13.0177 20.1875 13.4375 19.7677 13.4375 19.25V11.75C13.4375 11.2323 13.0177 10.8125 12.5 10.8125C11.9823 10.8125 11.5625 11.2323 11.5625 11.75V19.25C11.5625 19.7677 11.9823 20.1875 12.5 20.1875ZM12.5 6.75C13.1904 6.75 13.75 7.30965 13.75 8C13.75 8.69035 13.1904 9.25 12.5 9.25C11.8096 9.25 11.25 8.69035 11.25 8C11.25 7.30965 11.8096 6.75 12.5 6.75Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSobre);
export default __webpack_public_path__ + "static/media/sobre.a44a6867d0a532eba8ea44cf81d7ee06.svg";
export { ForwardRef as ReactComponent };